import {createFromIconfontCN} from '@ant-design/icons';

const IconFont = createFromIconfontCN({
    scriptUrl: '//p.gsxcdn.com/1373640433_3bm90rlf.js',
});

export default IconFont;
